import { useEffect } from 'react';

type Loader<T> = () => Promise<T>;

/**
 * Use to trigger pre-loading a lazy component. Typically used when some
 * feature is accessed via some UI that's displayed conditionally -  for
 * example, the components to trigger translating a message body and
 * rendering it are only rendered if the user clicks the Translate button,
 * and that component is in turn only rendered for messages from other users
 * that are in a language different than the current one. This avoids loading
 * the translation bundle at all if its never needed; and when it is relevant,
 * it's loaded when the Translate button is first rendered, so is ready to
 * run when/if the user clicks that button.
 */
type UsePreloadComponent = <T>(loader: Loader<T>) => void;
export const usePreloadComponent: UsePreloadComponent = (loader) => {
  'use memo';

  useEffect(() => {
    loader();
  }, [loader]);
};
